import { formatarNumero } from '@/lib/formato';
import { useContagem } from '@/lib/movimento';

/** Número que conta até o novo valor quando muda (lote processando, KPIs). */
export function Contador({ valor, className }: { valor: number; className?: string }) {
  const atual = useContagem(valor);
  return <span className={`tabular ${className ?? ''}`}>{formatarNumero(atual)}</span>;
}
